import React from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import useHovered from 'hooks/useHovered'

import { NAVIGATION_TYPES } from '../../../../constants'

import ActionsDropdown, { TYPES } from '../../../components/ActionsDropdown/ActionsDropdown'

import rocketIcon from './i/rocket.svg'
import finishIcon from './i/finish.svg'

import './Page.scss'

const LimitPage = ({ methods, isSelected, navigationType }) => {
    const { t } = useTranslation()

    const [isHovered, onMouseOver, onMouseLeave] = useHovered()

    return (
        <div
            className={classNames(
                'internal-pages__wrapper',
                'internal-pages__special-wrapper',
                'internal-pages__limit-wrapper',
            )}
        >
            <div
                onClick={() => methods.onSelect()}
                className={classNames('internal-pages__page', { 'is-select': isSelected })}
                onMouseOver={onMouseOver}
                onMouseLeave={onMouseLeave}
            >
                <div className="internal-pages__page-label">
                    {navigationType === NAVIGATION_TYPES.START && t('Coming soon')}
                    {navigationType === NAVIGATION_TYPES.END && t('Project ended')}
                </div>

                <div className="internal-pages__special-page__img">
                    {navigationType === NAVIGATION_TYPES.START && <img src={rocketIcon} alt="" />}
                    {navigationType === NAVIGATION_TYPES.END && <img src={finishIcon} alt="" />}
                </div>

                <ActionsDropdown type={TYPES.TIME} isVisible={isHovered || isSelected} />
            </div>
        </div>
    )
}

export default LimitPage
